
import { defineComponent, onMounted, ref, inject, computed } from "vue"
import { useStore } from "vuex";
import clubService from "@/core/services/InstitutionService"
import GlobalService from "@/core/services/GlobalService";
import { errManager, confirmDelete, showNotification } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n/index";

//components
import AfiliationsDrawer from "./components/AfiliationsDrawer.vue";
import AddEditClubDrawer from "./components/AddEditClubDrawer.vue";
import UploadFileModal from "@/components/modals/general/UploadFileModal.vue"

export default defineComponent({
    name: "Clubs",
    components: {
        AfiliationsDrawer,
        AddEditClubDrawer,
        UploadFileModal
    },
    setup() {
        const { t } = useI18n();
        const store = useStore();
        const loader = ref(false)
        const REPO = ref(process.env.VUE_APP_REPO)
        const altura = screen.height - 380;
        const popoverFilters = ref(false);
        const filter = ref({
            idzone: '',
            search: '',
            category: [] as number[],
            type: [] as number[],
            limit: '',
            page: '',
        })
        const setting = ref({
            categories: <any>[],
            types: <any>[],
        })
        const rowItem = ref({})
        const listClubs = ref<any>([]);
        const loadingId = ref<number | null>(null)

        //Pagination start
        const pageSize = ref(12)
        const currentPage = ref(1)
        const totalItems = ref(0)
        //pagination 

        const actionDrawer = ref('');
        const AddEditClubDrawerRef = ref<any>(null);
        const AfiliationsDrawerRef = ref<any>(null);

        //upload file
        const paramsUpload = ref<any>({});
        const uploadPhotoRef = ref<any>(null);
        

        const company = computed(() => {
            return store.getters.currentUser.company
        });

        const listZone = computed(() => {
            return store.getters.currentUser.zone;
        })

        const getSetting = async () => {
            await clubService.getSetting()
                .then((res) => {
                    setting.value = res.data;

                    if(setting.value?.categories){
                        filter.value.category = setting.value?.categories.map((item: { iddetails: string }) => item.iddetails);
                    }

                    if(setting.value?.types){
                        filter.value.type = setting.value?.types.map((item: { iddetails: string }) => item.iddetails)
                    }

                }).catch(({ response }) => {
                    errManager(response, null, 2)
                })
        }

        const getData = async () => {
            loader.value = true;
            popoverFilters.value = false;
            filter.value.limit = String(pageSize.value);
            filter.value.page = String(currentPage.value);
           
            const params = new URLSearchParams({
                ...filter.value,
                category: filter.value.category.join(','),
                type: filter.value.type.join(','),
            });

            await GlobalService.get('api', `institution?${params}`)
                .then((res) => {
                    listClubs.value = res.data.data
                    totalItems.value = res.data.total
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const handleSizeChange = (val: number) => {
            pageSize.value = val
            getData();
        }

        const handleCurrentChange = (val: number) => {
            currentPage.value = val
            getData()
        }

        const onRegister = () => {
            if(AddEditClubDrawerRef.value){
                actionDrawer.value = 'new';
                rowItem.value = {};
                AddEditClubDrawerRef.value.openDrawer();
            }
        }

        const onEdit = (row) => {
            if(AddEditClubDrawerRef.value){
                actionDrawer.value = 'edit';
                rowItem.value = row;
                AddEditClubDrawerRef.value.openDrawer();
            }
        }

        const onResponse = (data) => {
            if (data.status == 'success')
                getData();
        }

        const onDelete = (row) => {
            confirmDelete({
                module: 'institution',
                id: row.idinstitution,
                name: row.name,
                t,
                onSuccess: getData,
                payload: { mstatus: 0 }
            });
        };

        const openDrawerAfiliations = (row: any) => {
            if(AfiliationsDrawerRef.value){
                AfiliationsDrawerRef.value.openDrawer();
            }
        };

        const openUpload = (row) => {
            if (uploadPhotoRef.value) {
                paramsUpload.value.id = btoa(row?.idinstitution);
                paramsUpload.value.alias = 'AVATAR';
                paramsUpload.value.folder = 'unis';
                paramsUpload.value.destiny = 'institution';
                uploadPhotoRef.value.openModal();
            }
        };

        const onChangeStatus = async (item: any): Promise<boolean> => {
            const id = Number(item.idinstitution)
            const currentStatus = Number(item.mstatus)
            const newStatus = currentStatus === 1 ? 2 : 1

            if (loadingId.value !== null) {
                return false
            }

            loadingId.value = id

            try {
                const response: any = await GlobalService.delete(
                    'institution', 
                    `${id}/delete`, {
                        idinstitution: id,
                        mstatus: newStatus,
                });

                

                if (response?.status === 200 || response?.success || response?.data) {
                    item.mstatus = newStatus
                    item.status = {
                        ...item.status,
                        name: newStatus === 1 ? 'Activo' : 'Inactivo',
                        params: newStatus === 1 ? 'success' : 'secondary',
                    }

                    showNotification(response.data);

                    return true
                }

                showNotification(response.data);
                return false
            } catch (error: any) {
                showNotification({title: 'Error', message: 'Ocurrió un error al actualizar el estado.', status: 'error' })
                return false
            } finally {
                loadingId.value = null
            }
        };

        onMounted(async () => {
            await getSetting()
            getData()
        })

        return {
            t,
            loader,
            REPO,
            filter,
            altura,
            setting,
            listClubs,
            company,
            popoverFilters,
            actionDrawer,
            listZone,
            paramsUpload,
            AddEditClubDrawerRef,
            AfiliationsDrawerRef,
            uploadPhotoRef,
            loadingId,
            //page
            pageSize,
            currentPage,
            totalItems,
            handleSizeChange,
            handleCurrentChange,
            rowItem,
            //events
            getSetting,
            getData,
            onRegister,
            onEdit,
            onDelete,
            onResponse,
            openDrawerAfiliations,
            openUpload,
            onChangeStatus
        }

    },
})
